// extracted by mini-css-extract-plugin
export default {"bookingItem":"UpcomingBookingItem_bookingItem__CaQ-p"};